import type { PropertyPreviewProps } from "@firecms/core";
import { CURRENCIES } from "./money";

type Fees = Record<string, number | undefined>;
type Rate = { maxGrams?: number; fees?: Fees };

/**
 * 運費清單列高固定且 overflow 隱藏。幣別若直排或換行，美元會被裁掉。
 * 金額為 0 照樣顯示；沒填的幣別顯示 —，不代表免運。
 */
export function ShippingFeesPreview({ value }: PropertyPreviewProps<Fees>) {
  return <CurrencyLine fees={value} />;
}

/** 清單上的每個重量級距：重量與各幣別同一行。 */
export function ShippingRatesPreview({ value }: PropertyPreviewProps<Rate[]>) {
  const rates = Array.isArray(value) ? value : [];
  if (rates.length === 0) return <span className="whitespace-nowrap text-sm">—</span>;
  return (
    <span className="flex flex-col gap-0.5 text-sm leading-tight">
      {rates.map((rate, index) => (
        <span key={index} className="whitespace-nowrap">
          {rate?.maxGrams != null ? <span className="mr-3">≤{rate.maxGrams}g</span> : null}
          <CurrencyLine fees={rate?.fees} />
        </span>
      ))}
    </span>
  );
}

function CurrencyLine({ fees }: { fees?: Fees }) {
  return (
    <span className="inline-flex flex-nowrap items-baseline gap-x-3 whitespace-nowrap">
      {Object.keys(CURRENCIES).map((currency) => (
        <span key={currency}>
          {currency} {fees?.[currency] ?? "—"}
        </span>
      ))}
    </span>
  );
}
